const BenefitBoardData = [
  {
    id: 1,
    imgSrc: require('../assets/images/LHOTDK_3.png'),
    description:
      'Những kiến thức đại cương được hệ thống hoá, truyền đạt với ngôn ngữ sinh viên gần gũi, dễ hiểu',
  },
  {
    id: 2,
    imgSrc: require('../assets/images/LHOTDK_4.png'),
    description: 'Cơ hội rèn luyện các dạng bài tập quan trọng, thường gặp trong đề thi ',
  },
  {
    id: 3,
    imgSrc: require('../assets/images/LHOTDK_5.png'),
    description:
      'Kỹ năng làm đề thi từ những bộ đề do chính Ban Chuyên môn Câu lạc bộ Chúng Ta Cùng Tiến biên soạn',
  },
  {
    id: 4,
    imgSrc: require('../assets/images/LHOTDK_6.png'),
    description: 'Phòng học thoải mái, những người bạn học chăm chỉ',
  },
  {
    id: 5,
    imgSrc: require('../assets/images/LHOTDK_7.png'),
    description: 'Được giải đáp thắc mắc tận tình sau buổi học',
  },
];

export default BenefitBoardData;
